/**
 * Created by h3 on 2017-11-30.
 */
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {Tesla} from "../Tesla";
import {TeslaParsedGameData} from "../server/data/TeslaParsedGameData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

export class TeslaSpinController extends SpinController {
    private _wildsCollected:number[];
    private _overlayWilds:boolean[][];
    private _isFreespin:boolean;
    private _overlayWildsBeforeSpinStop:boolean[][];
    private _dischargeWild:boolean;
    private _isRestore:boolean = false;
    private _bonusSymbolTriggered:boolean;
    private _freespinsLeft:number | undefined;
    private _extraFreespinRewarded:number;
    private _reels:string[][];


    constructor() {
        super();
    }


    protected parseGameData(data:TeslaParsedGameData):void {

        if(data instanceof ParsedInitData) {
            this._isRestore = (<ParsedInitData>data).isRestoreState;
        }

        this._wildsCollected = data.wildsCollected;
        this._overlayWilds = data.overlayWilds!;
        this._overlayWildsBeforeSpinStop = data.overlayWildsBeforeSpinStop;
        this._dischargeWild = data.dischargeWild;
        this._isFreespin = data.mode == GameMode.FREESPIN;
        this._bonusSymbolTriggered = data.bonusSymbolTriggered;
        this._freespinsLeft = data.freespinsLeft;
        this._reels = data.reels;
        this._extraFreespinRewarded = data.extraFreespinRewarded;

        this.getStopDelay();
    }

    private getWildsCollectedBeforeSpinStop():number[] {

        if(!this._overlayWildsBeforeSpinStop) {
            return [0, 0, 0, 0, 0];
        }


        if(!this._bonusSymbolTriggered && this._dischargeWild) {
            return this._wildsCollected;
        }

        if(this._freespinsLeft === this._extraFreespinRewarded) {
            return this._wildsCollected;
        }

        let wildsCollectedBeforeSpinStop = [];

        for(let i = 0; i < this._overlayWilds.length; i++) {
            let collected = 0;
            for(let j = 0; j < this._overlayWilds[i].length; j++) {
                if(this._overlayWilds[i][j]) {
                    collected++;
                }
            }

            if(collected === 3) {
                collected = 0;
            }


            if(this._wildsCollected[i] !== 0) {
                if(this._reels[i][1] === "W2" || this._reels[i][2] === "W2" || this._reels[i][3] === "W2") {
                    collected = this._wildsCollected[i] - 1;
                } else {
                    collected = this._wildsCollected[i];
                }
            }

            wildsCollectedBeforeSpinStop.push(collected);

        }

        return wildsCollectedBeforeSpinStop;
    }

    protected getStopDelay():void {
        if(!this._isFreespin) {
            return;
        }
        const tl:TimelineLite = new TimelineLite();
        let releaseIndicatorTimeline:TimelineLite[] = Tesla.wildCollectRelease.getPreSpinStopAnimation(this._overlayWildsBeforeSpinStop);

        if(releaseIndicatorTimeline.length < 1) {
            if(this._isRestore) {
                this._isRestore = false;
            }
            return;
        }


        if(this._dischargeWild) {
            tl.add(Tesla.wildCollectRelease.getDischargeWildAnimation());
        }

        let wildIndicatorTimeline:TimelineLite[] = Tesla.wildCollectIndicator.getWinAnimation(this.getWildsCollectedBeforeSpinStop());

        if(this._isRestore) {
            this._isRestore = false;
            for(let i:number = 0; i < releaseIndicatorTimeline.length; i++) {
                tl.add([
                    wildIndicatorTimeline[i],
                    releaseIndicatorTimeline[i]
                ]);
            }
        } else {
            for(let i:number = 0; i < releaseIndicatorTimeline.length; i++) {
                tl.add([
                    wildIndicatorTimeline[i],
                    releaseIndicatorTimeline[i]
                ]);
            }
        }

        this.dispatchAddStopDelay(tl.totalDuration());

    }

    private dispatchAddStopDelay(delay:number) {
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.ADD_STOP_DELAY, delay));
    }

}